import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const Head = styled.h3`
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: #555658;
  margin: 0;
  text-align: left;
`;
